// GREY custom "Urunler" desktop mega menu - kategori sekme gecisi.
// Sadece navigasyon UI'sini yonetir; urun/sepet/checkout kodlarina dokunmaz.
(function () {
  function activate(btn) {
    var root = btn.closest('.grey-mega-menu');
    if (!root) return;
    var cat = btn.getAttribute('data-cat');
    root.querySelectorAll('.grey-mega-menu__cat-btn').forEach(function (b) {
      var isActive = b === btn;
      b.classList.toggle('is-active', isActive);
      b.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
    root.querySelectorAll('.grey-mega-menu__panel').forEach(function (p) {
      p.hidden = p.getAttribute('data-panel') !== cat;
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.grey-mega-menu__cat-btn');
    if (btn) activate(btn);
  });

})();
